//平台-小程序订单
const programOrder = () => import('@/components/platform/operation/programOrder')

// 考试管理
const testClassify = () => import('@/components/testSystem/trainExam/testClassify') //试题分类
const testTopic = () => import('@/components/testSystem/trainExam/testTopic')
const addTestTopic = () => import('@/components/testSystem/trainExam/addTestTopic')

const testPaper = () => import('@/components/testSystem/trainExam/testPaper') //试卷库
const sharedTest = () => import('@/components/testSystem/trainExam/sharedTest') //共享考试
const newPaper = () => import('@/components/testSystem/trainExam/paperLibrary/newPaper') //新增试卷
const Achievements = () => import('@/components/testSystem/trainExam/paperLibrary/Achievements') //考试详情
const details = () => import('@/components/testSystem/trainExam/paperLibrary/details') //考试详情

const examManage = () => import('@/components/testSystem/trainExam/examManage')
const seeAchievement = () => import('@/components/testSystem/trainExam/seeAchievement')
const addExam = () => import('@/components/testSystem/trainExam/addExam') //运营中心
const addExams = () => import('@/components/testSystem/trainExam/addExams') //商户中心有共享

const studyData = () => import('@/components/testSystem/trainExam/studyData')

//考试系统--用户模块
const testHome = () => import('@/components/testSystem/userModules/testHome')
const testing = () => import('@/components/testSystem/userModules/testing')
const testInfo = () => import('@/components/testSystem/userModules/testInfo')
const testPreview = () => import('@/components/testSystem/userModules/testPreview')
const myTest = () => import('@/components/testSystem/userModules/myTest')
const myCertificate = () => import('@/components/testSystem/userModules/myCertificate')
const wrongTopic = () => import('@/components/testSystem/userModules/wrongTopic')
const viewResult = () => import('@/components/testSystem/userModules/viewResult')

// 系统公告
const notice = () => import('@/components/platform/contentManagement/notice/index')
const noticeModify = () => import('@/components/platform/contentManagement/notice/modify')
const noticeDetail = () => import('@/components/platform/contentManagement/notice/detail')
// 轮播管理
const rotation = () => import('@/components/platform/contentManagement/rotation/index')
// 版本列表
const version = () => import('@/components/platform/contentManagement/version/index')
const versionModify = () => import('@/components/platform/contentManagement/version/modify')
const versionDetail = () => import('@/components/platform/contentManagement/version/detail')
const versionProductDetail = () => import('@/components/index/versionDetail')

// 工单管理-常见问题
const frequentlyQues = () => import('@/components/platform/workSheet/frequentlyQues/index')
// 工单管理-常见问题-新增问答
const addQuestion = () => import('@/components/platform/workSheet/frequentlyQues/addQuestion')
// 首页-常见问题
const frequentlyQuestion = () => import('@/components/index/frequentlyQuestion/index')
// 5.2需求  操作手册
const operationManual = () => import('@/components/index/operationManual')
const operationManualView = () => import('@/components/index/operationManualView')
const video = () => import('@/components/index/video')
// 解决方案 平台
const solution = () => import('@/components/platform/solution/index')
const addSolution = () => import('@/components/platform/solution/page/addSolution')
const nodeManage = () => import('@/components/platform/solution/page/nodeManage')
const addNode = () => import('@/components/platform/solution/page/addNode')
const stepManage = () => import('@/components/platform/solution/page/stepManage')
const scenario = () => import('@/components/platform/solution/scenario')
const addScenario = () => import('@/components/platform/solution/page/addScenario')
const exceptionLog = () => import('@/components/platform/exceptionLog')
// 5.6 平台-题目管理
const topicManagement = () => import('@/components/platform/topicManagement/index');
const addSubject = () => import('@/components/platform/topicManagement/addSubject');
// 消息模块
const informationAA = () => import('@/components/platform/information/page/informationList')
const productImgs = () => import('@/components/productImgs/index'); //商品图库
// 服务管理
const serviceManger = () => import('@/components/product/serviceManger/serviceManger')


export default [{
    path: "/programOrder",
    meta: {
      text: '小程序订单',
    },
    name: 'programOrder',
    component: programOrder
  },
  {
    path: "/testClassify",
    meta: {
      text: '试题分类',
    },
    name: 'testClassify',
    component: testClassify
  }, {
    path: "/testTopic",
    meta: {
      text: '试题库',
    },
    name: 'testTopic',
    component: testTopic
  }, {
    path: "/addTestTopic",
    meta: {
      text: '新增试题',
    },
    name: 'addTestTopic',
    component: addTestTopic
  }, {
    path: "/testPaper",
    meta: {
      text: '试卷库',
    },
    name: 'testPaper',
    component: testPaper
  }, {
    path: "/newPaper",
    meta: {
      text: '新增试卷',
    },
    name: 'newPaper',
    component: newPaper
  }, {
    path: "/examManage",
    meta: {
      text: '考试管理',
    },
    name: 'examManage',
    component: examManage
  }, {
    path: "/examManage/seeAchievement",
    meta: {
      text: '考试详情',
    },
    name: 'seeAchievement',
    component: seeAchievement
  }, {
    path: "/examManage/details",
    meta: {
      text: '成绩查看',
    },
    name: 'details',
    component: details
  }, {
    path: "/sharedTest/Achievements",
    meta: {
      text: '考试详情',
    },
    name: 'Achievements',
    component: Achievements
  }, { //运营中心
    path: "/addExam",
    meta: {
      text: '新增考试',
    },
    name: 'addExam',
    component: addExam
  }, { //商户中心-共享
    path: "/addExams",
    meta: {
      text: '新增考试',
    },
    name: 'addExams',
    component: addExams
  }, {
    path: "/studyData",
    meta: {
      text: '学习资料管理',
    },
    name: 'studyData',
    component: studyData
  }, {
    path: "/sharedTest",
    meta: {
      text: '共享考试',
    },
    name: 'sharedTest',
    component: sharedTest
  },
  {
    path: "/testHome",
    component: testHome,
    meta: {
      text: '培训考试'
    }
  }, {
    meta: {
      text: '我的考试',
    },
    path: "/myTest",
    component: myTest,
  }, {
    meta: {
      text: '我的证书',
    },
    path: "/myCertificate",
    component: myCertificate,
  }, {
    meta: {
      text: '我的错题库',
    },
    path: "/wrongTopic",
    component: wrongTopic,
  }, {
    meta: {
      text: '考试信息',
    },
    path: "/viewResult",
    component: viewResult,
  },
  //进行考试
  {
    path: '/testing',
    name: 'testing',
    meta: {
      noStore: true,
    },
    component: testing,
  }, {
    path: '/testInfo',
    name: 'testInfo',
    meta: {
      noStore: true,
    },
    component: testInfo,
  }, {
    path: '/testPreview',
    name: 'testPreview',
    meta: {
      noStore: true,
    },
    component: testPreview,
  },
  {
    path: "/notice/index",
    name: "notice",
    component: notice,
    meta: {
      text: '系统公告'
    }
  }, {
    path: "/notice/modify",
    name: "noticeModify",
    component: noticeModify,
    meta: {
      text: '公告修改'
    }
  }, {
    path: "/notice/detail",
    name: "noticeDetail",
    component: noticeDetail,
    meta: {
      text: '公告详情'
    }
  }, {
    path: "/rotation/index",
    name: "rotation",
    component: rotation,
    meta: {
      text: '轮播管理'
    }
  },
  {
    path: "/version/index",
    name: "version",
    component: version,
    meta: {
      includes: ['plat'],
      text: '版本列表'
    }
  }, {
    path: "/version/modify",
    name: "versionModify",
    component: versionModify,
    meta: {
      includes: ['plat'],
      text: '版本修改'
    }
  }, {
    path: "/version/detail",
    name: "versionDetail",
    component: versionDetail,
    meta: {
      includes: ['plat'],
      text: '版本详情'
    }
  }, {
    path: "/versionProductDetail",
    name: "versionProductDetail",
    component: versionProductDetail,
    meta: {
      text: '版本详情'
    }
  },
  // 平台-常见问题
  {
    path: "/frequentlyQues",
    name: "frequentlyQues",
    component: frequentlyQues,
    meta: {
      text: '常见问题'
    }
  },
  // 商户-常见问题
  {
    path: "/frequentlyQuestion",
    name: "frequentlyQuestion",
    component: frequentlyQuestion,
    meta: {
      text: '常见问题'
    }
  }, {
    path: "/addQuestion",
    name: "addQuestion",
    component: addQuestion,
    meta: {
      text: '新增问答'
    }
  },
  // 操作手册
  {
    path: '/operationManual',
    name: 'operationManual',
    meta: {
      text: '操作手册',
    },
    component: operationManual,
  },
  {
    path: '/operationManualView',
    name: 'operationManualView',
    meta: {
      noStore: true,
    },
    component: operationManualView
  },
  //视频讲解
  {
    path: '/video',
    name: 'video',
    meta: {
      text: '视频讲解',
    },
    component: video,
  },
  // 解决方案
  {
    path: '/solution',
    component: solution,
    children: [{
        meta: {
          text: '解决方案',
        },
        path: "mySolution",
        name: 'mySolution',
        component: resolve => {
          require(['@//components/platform/solution/mySolution.vue'],
            resolve)
        },
      },

      {
        meta: {
          text: '业务版块',
        },
        path: "businessEdition",
        name: 'businessEdition',
        component: resolve => {
          require(['@//components/platform/solution/businessEdition.vue'],
            resolve)
        },
      }
    ]
  }, {
    meta: {
      text: '共享方案',
    },
    path: "sharingPlan",
    name: 'sharingPlan',
    component: resolve => {
      require(['@//components/platform/solution/sharingPlan.vue'], resolve)
    },
  }, {
    path: '/addSolution',
    name: 'addSolution',
    meta: {
      text: '添加解决方案',
    },
    component: addSolution
  }, {
    path: '/nodeManage',
    name: 'nodeManage',
    meta: {
      text: '方案节点管理',
    },
    component: nodeManage
  }, {
    path: '/addNode',
    name: 'addNode',
    meta: {
      text: '添加节点',
    },
    component: addNode
  }, {
    path: '/stepManage',
    name: 'stepManage',
    meta: {
      text: '节点步骤管理',
    },
    component: stepManage
  },
  // 方案内容库
  {
    path: '/scenario',
    name: 'scenario',
    meta: {
      text: '方案内容库',
    },
    component: scenario
  }, {
    path: '/addScenario',
    name: 'addScenario',
    meta: {
      text: '添加方案',
    },
    component: addScenario
  },
  {
    path: '/exceptionLog',
    name: 'exceptionLog',
    meta: {
      text: '异常日志中心',
    },
    component: exceptionLog
  },
  {
    path: '/topicManagement',
    name: 'topicManagement',
    meta: {
      text: '题目管理',
    },
    component: topicManagement
  },
  {
    path: '/addSubject',
    name: 'addSubject',
    meta: {
      text: '添加题目',
    },
    component: addSubject
  },
  { //消息模块
    path: "/information/informationList",
    name: 'informationAA',
    component: informationAA,
    meta: {
      text: '消息模块',
    },
  },
  {
    path: '/productImgs',
    name: 'productImgs',
    meta: {
      text: '商品图库',
    },
    component: productImgs,
  },
  {
    path: '/product/serviceManger',
    name: 'serviceManger',
    meta: {
      text: '服务管理',
    },
    component: serviceManger
  },
]
